import { render, staticRenderFns } from "./ExamRuleItem.vue?vue&type=template&id=b3ca7488"
import script from "./ExamRuleItem.vue?vue&type=script&lang=js"
export * from "./ExamRuleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports